module.exports = __webpack_public_path__ + "img/fly-active.c7611070.svg";